import type React from 'react';

import { useState } from 'react';

import CompanyUserModal from '@/components/company/companyUserModal/CompanyUser.modal.tsx';
import { LrmOperatingLocationsWarningDialog } from '@/components/lrmWarning/components/LrmOperatingLocationsWarningDialog.comp';
import { useLrmOperatingLocationsWarning } from '@/components/lrmWarning/util/useLrmOperatingLocationsWarning.util.ts';
import { useGetEmployeeDetails } from '@/views/userDetails/util/useGetEmployeeDetails.util.ts';

export const LrmWarningDialogManager: React.FC = () => {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const { employeeDetails, getEmployeeDetails } = useGetEmployeeDetails();

  const { closeDialog, isDialogOpen, openEditProfile } = useLrmOperatingLocationsWarning(
    async () => {
      await getEmployeeDetails(true);
      setIsEditDialogOpen(true);
    },
  );

  const handleCloseEditDialog = () => {
    setIsEditDialogOpen(false);
  };

  const handleRefreshData = async () => {
    await getEmployeeDetails(true);
  };

  return (
    <>
      <LrmOperatingLocationsWarningDialog
        onClose={closeDialog}
        onEditProfile={openEditProfile}
        open={isDialogOpen}
      />
      {isEditDialogOpen && employeeDetails && (
        <CompanyUserModal
          editedProfile={employeeDetails}
          myProfileView={true}
          onClose={handleCloseEditDialog}
          onRefreshData={handleRefreshData}
        />
      )}
    </>
  );
};
